var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrayItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 70.9h56.6c0.9 0 1.7 0.8 1.7 1.7v4.9c0 0.9-0.8 1.7-1.7 1.7H6.7c-0.9 0-1.7-0.8-1.7-1.7v-4.9C5 71.7 5.8 70.9 6.7 70.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 58.4h56.6c0.9 0 1.7 0.8 1.7 1.7V65c0 0.9-0.8 1.7-1.7 1.7H6.7C5.8 66.7 5 65.9 5 65v-4.9C5 59.1 5.8 58.4 6.7 58.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 45.8h56.6c0.9 0 1.7 0.8 1.7 1.7v4.9c0 0.9-0.8 1.7-1.7 1.7H6.7c-0.9 0-1.7-0.8-1.7-1.7v-4.9C5 46.6 5.8 45.8 6.7 45.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 33.3h56.6c0.9 0 1.7 0.8 1.7 1.7v4.9c0 0.9-0.8 1.7-1.7 1.7H23.9c-0.9 0-1.7-0.8-1.7-1.7V35C22.1 34.1 22.9 33.3 23.9 33.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 20.7h56.6c0.9 0 1.7 0.8 1.7 1.7v4.9c0 0.9-0.8 1.7-1.7 1.7H6.7c-0.9 0-1.7-0.8-1.7-1.7v-4.9C5 21.5 5.8 20.7 6.7 20.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1 28.6l11.6 6.7c1.7 1 1.7 3.5 0 4.5l-11.6 6.7c-1.7 1-3.9-0.2-3.9-2.2V30.8C78.3 28.8 80.4 27.6 82.1 28.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrayItem);
export default __webpack_public_path__ + "static/media/arrayItem.78fed3b16fda14edc2b60aa878da109d.svg";
export { ForwardRef as ReactComponent };